/**
 * @description Return the start of a month for a given date.
 *
 * @param {Date} date Date to find start of month of.
 *
 * @returns {Date} Date of start of month.
 */
export var startOfMonth = function (date) {
    var dateToMutate = new Date(date);
    dateToMutate.setDate(1);
    dateToMutate.setHours(0, 0, 0, 0);
    return dateToMutate;
};
//# sourceMappingURL=startOfMonth.js.map